import React, { useRef, useState } from "react";
import {
  Box,
  Link,
  Chip as MuiChip,
  IconButton,
  useMediaQuery,
  Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import styled from "@emotion/styled";
import PopoverTarga from "../../components/PopoverTarga";
import useAuth from "../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { Person, AccountBalance } from "@mui/icons-material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useSelector } from "react-redux";
import PopoverReboot from "../../components/PopoverReboot";
import { useTheme } from "@mui/system";

const Chip = styled(MuiChip)`
  height: 20px;
  padding: 4px 0;
  font-size: 90%;
  background-color: ${(props) =>
    props.theme.palette[props.color ? props.color : "primary"]};
  color: ${(props) => props.theme.palette.common.white};
`;

export const useGetRichiesteColumns = () => {
  const { getData } = useAuth();
  const theme = useTheme();
  const isSmallDevice = useMediaQuery("(max-width:1000px)");
  const [userData, setUserData] = useState(null);
  const [targaData, setTargaData] = useState(null);
  const [canViewUserData, setCanViewUserData] = useState(false);
  const [canViewTargaData, setCanViewTargaData] = useState(false);
  const [isTargaPopupOpen, setIsTargaPopupOpen] = useState(false);
  const [isRebootPopupOpen, setIsRebootPopupOpen] = useState(false);
  const [isUserPopupOpen, setIsUserPopupOpen] = useState(false);
  const [currentTargaRef, setCurrentTargaRef] = useState(null);
  const [currentUserRef, setCurrentUserRef] = useState(null);
  const [currentRebootRef, setCurrentRebootRef] = useState(null);
  const role = useSelector((state) => state.role.role);
  const isAdm = ["supAdm", "adm"].includes(role);
  const rebootRefs = useRef({});
  const targaRefs = useRef({});
  const userRefs = useRef({});
  const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const handleCloseTargaPopup = () => {
    setIsTargaPopupOpen(false);
    setCurrentTargaRef(null);
  };

  const handleCloseRebootPopup = () => {
    setIsRebootPopupOpen(false);
    setCurrentRebootRef(null);
  };

  const handleCloseUserPopup = () => {
    setIsUserPopupOpen(false);
    setCurrentUserRef(null);
  };

  const handleOpenTargaPopup = (ref, targaId) => {
    getData({
      action: "getPreviewInfo",
      type: "targa",
      value: targaId,
    })
      .then((response) => {
        setTargaData(response?.data);
        setCanViewTargaData(Boolean(response?.status === 1));
        setIsTargaPopupOpen(true);
        setCurrentTargaRef(ref);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleOpenUserPopup = (ref, utenteIDUID) => {
    getData({
      action: "getPreviewInfo",
      type: "utente",
      value: utenteIDUID,
    })
      .then((response) => {
        setUserData(response?.data);
        setCanViewUserData(Boolean(response?.status === 1));
        setIsUserPopupOpen(true);
        setCurrentUserRef(ref);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const column = [
    {
      field: "Targa",
      headerName: "Targa",
      sortable: false,
      filterable: false,
      minWidth: 200,
      width: 175,

      renderCell: (params) => {
        const {
          targa,
          tipoVeicolo,
          idUID,
          idUidTarga,
          idUidPrev,
          rebootTarga,
          dataMora,
        } = params.row;
        const ref = (el) => {
          targaRefs.current[params.id] = el;
        };
        const ref2 = (el) => {
          rebootRefs.current[params.id] = el;
        };
        const canReboot = isAdm && rebootTarga && rebootTarga > 0;

        return (
          <Box
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <PopoverReboot
              idUID={idUID}
              targa={targa}
              isRebootPopoverOpen={
                isRebootPopupOpen &&
                currentRebootRef === rebootRefs.current[params.id]
              }
              handleCloseRebootPopup={handleCloseRebootPopup}
              rebootRef={rebootRefs.current[params.id]}
            />
            {canReboot && (
              <IconButton
                ref={ref2}
                onClick={() => {
                  setIsRebootPopupOpen(true); // Open the popover
                  setCurrentRebootRef(rebootRefs.current[params.id]); // Set the correct reference
                }}
              >
                <RestartAltIcon />
              </IconButton>
            )}
            <IconButton
              ref={ref}
              onClick={() =>
                handleOpenTargaPopup(targaRefs.current[params.id], idUID)
              }
              size="small"
              sx={{
                margin: "0 4px",
              }}
            >
              <InfoIcon fontSize="small" />
            </IconButton>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <PopoverTarga
                data={targaData}
                idUID={idUID}
                canViewTargaData={canViewTargaData}
                isTargaPopupOpen={
                  isTargaPopupOpen &&
                  currentTargaRef === targaRefs.current[params.id]
                }
                handleCloseTargaPopup={handleCloseTargaPopup}
                targaRef={targaRefs.current[params.id]}
                params={params.row}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Link
                  sx={{
                    cursor: "pointer",
                    minWidth: "62px",
                    color:
                      theme.palette.mode === "light" ? "#0c4bb7" : "#5c92e1",
                    fontWeight: 900,
                  }}
                  onClick={() =>
                    handleNavigation(
                      `/pages/rcAutoDetails/${idUidTarga}/${idUidPrev}`
                    )
                  }
                >
                  {targa}
                </Link>
              </Box>

              <Box sx={{ fontSize: "smaller", fontWeight: 900 }}>
                {tipoVeicolo}
              </Box>
              <Box sx={{ fontSize: "smaller", fontWeight: 900 }}>
                Data Mora: {dataMora}
              </Box>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "tipologia",
      headerName: "Richiesta",
      sortable: false,
      filterable: false,
      minWidth: 200,
      width: 175,
      renderCell: (params) => {
        const { idStatoRichiesta, tipologia } = params.row;
        let color;
        let label;

        switch (idStatoRichiesta) {
          case 1:
            color = "#16669bff";
            label = "Aperta";
            break;
          case 5:
            color = "#16669bff";
            label = "In lavorazione gestore";
            break;
          case 6:
            color = "#327934ff";
            label = "Approvata";
            break;
          case 7:
            color = "#f44336";
            label = "Rifiutata";
            break;
          case 10:
            color = "#f48b36";
            label = "Integrazione dati";
            break;
          case 11:
            color = "#f44336";
            label = "Scaduta";
            break;
          case 12:
            color = "#1f5722ff";
            label = "Emessa";
            break;
          case 13:
            color = "#6c757d";
            label = "Archiviata";
            break;
          default:
            color = "grey";
            label = "Sconosciuto";
        }
        return (
          <Box>
            <Box display="flex" gap={2}>
              <span style={{ fontWeight: 900 }}>{tipologia}</span>
            </Box>
            <Box display="flex" flexDirection="column" mt={2}>
              <Box display="flex" gap={2}>
                <Chip
                  label={label}
                  sx={{ backgroundColor: color, fontWeight: "bold" }}
                />
              </Box>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "Cliente",
      headerName: "Cliente",
      sortable: false,
      filterable: false,
      minWidth: 250,
      width: 300,
      renderCell: (params) => {
        const {
          clienteRagSociale,
          clienteCognome,
          clienteNome,
          comuneResidenza,
        } = params.row;
        return (
          <Box>
            <Box>
              {clienteRagSociale ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <AccountBalance />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      marginLeft: "8px",
                    }}
                  >
                    <Box>{clienteRagSociale}</Box>
                    <Box sx={{ fontSize: "smaller", fontWeight: 900 }}>
                      {params.row.comuneSedeLegale}
                    </Box>
                  </Box>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Person />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      marginLeft: "8px",
                    }}
                  >
                    <Box>{`${clienteCognome} ${clienteNome}`}</Box>
                    <Box
                      sx={{
                        fontSize: "smaller",
                        fontWeight: 900,
                      }}
                    >
                      {comuneResidenza}
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        );
      },
    },
    {
      field: "CreataDa",
      headerName: "Creata da",
      sortable: false,
      filterable: false,
      minWidth: 150,
      width: 200,
      align: "left",
      renderCell: (params) => {
        const {
          utenteIDUID,
          utenteCognome,
          utenteNome,
          utenteAzienda,
          dataCreazione,
        } = params.row;
        const ref = (el) => {
          userRefs.current[params.id] = el;
        };

        return (
          <Box
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            {/* <IconButton
              ref={ref}
              onClick={() =>
                handleOpenUserPopup(userRefs.current[params.id], utenteIDUID)
              }
              size="small"
              sx={{
                margin: "0 8px",
              }}
            >
              <InfoIcon fontSize="small" />
            </IconButton>
            <Box>
              <PopoverUser
                data={userData}
                canViewUserData={canViewUserData}
                utenteIDUID={utenteIDUID}
                isUserPopupOpen={
                  isUserPopupOpen &&
                  currentUserRef === userRefs.current[params.id]
                }
                handleCloseUserPopup={handleCloseUserPopup}
                userRef={userRefs.current[params.id]}
                params={params.row}
              />
              <Link
                sx={{
                  cursor: "pointer",
                  color: theme.palette.mode === "light" ? "#0c4bb7" : "#5c92e1",
                  fontWeight: 900,
                }}
                onClick={() =>
                  handleNavigation(`/pages/profile/${utenteIDUID}`)
                }
              >{`${utenteCognome} ${utenteNome}`}</Link>

              <Box sx={{ fontSize: "smaller", fontWeight: 900 }}>
                {utenteAzienda}
              </Box>
            </Box> */}
            <Box>
              <Box display="flex" gap={2}>
                <span>
                  {utenteCognome} ({utenteAzienda})
                </span>
              </Box>
              <Box display="flex" gap={2}>
                <Typography sx={{ fontSize: "smaller", fontWeight: 900 }}>
                  {dataCreazione}
                </Typography>
              </Box>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "Assegnata",
      headerName: "Assegnata",
      sortable: false,
      filterable: false,
      minWidth: 200,
      width: 200,
      renderCell: (params) => {
        const {
          idStatoRichiesta,
          dataUltimaModifica,
          utenteNome,
          utenteCognome,
        } = params.row;

        return (
          <Box display="flex" flexDirection="column">
            <Box display="flex" gap={2}>
              <span>
                {utenteCognome} {utenteNome}
              </span>
            </Box>
            <Box display="flex" gap={2}>
              <Typography sx={{ fontSize: "smaller", fontWeight: 900 }}>
                {dataUltimaModifica}
              </Typography>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "premio",
      headerName: "Premio",
      sortable: false,
      filterable: false,
      minWidth: 300,
      flex: 1,
      renderCell: (params) => {
        const { CompagniaIcona, CompagniaNome, dataScadenza, premio } =
          params.row;
        const formattedPremio =
          premio === null || premio === undefined
            ? ""
            : (() => {
                const formatNumber = (num) => {
                  const parts = Number(num).toFixed(2).split(".");
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  return parts.join(",");
                };

                if (typeof premio === "number") return formatNumber(premio);

                const str = String(premio);
                const normalized = str.includes(",")
                  ? str.replace(",", ".")
                  : str;

                if (!isNaN(Number(normalized))) {
                  return formatNumber(Number(normalized));
                }
                if (str.includes(".")) return str;
                return `${premio},00`;
              })();

        return (
          <>
            <Box sx={{ display: "flex", flexDirection: "column", mr: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                  justifyContent: "start",
                }}
              >
                <img
                  src={`/static/img/companies/${CompagniaIcona}`}
                  alt={CompagniaNome}
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Box>
            <Box display="flex" flexDirection="column" justifyContent="center">
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                € {formattedPremio}
              </div>
              <Typography sx={{ fontSize: "smaller", fontWeight: 900 }}>
                Scade il {dataScadenza}
              </Typography>
            </Box>
          </>
        );
      },
    },
  ];

  return column;
};

//Aperta e In Lavorazione: blu

/*  if (completed)
            return <ChipItem color="success" customColor="#2e7d32" />;
          if (loading)
            return (
              <ChipItem color="warning" showLoading customColor="#ed6c02" />
            );
          if (action)
            return <ChipItem color="info" clickable customColor="#0f74b9" />;
          return <ChipItem color="error" customColor="#d32f2f" />;
         */

/*
          {
        "value": 1,
        "label": "Aperta"
    },
    {
        "value": 5,
        "label": "In lavorazione gestore" //Blu
    },
    {
        "value": 6,
        "label": "Approvata" //verde più scuro
    },
    {
        "value": 7,
        "label": "Rifiutata" // rossa
    },
    {
        "value": 10,
        "label": "Integrazione dati" // arancione
    },
    {
        "value": 11,
        "label": "Scaduta" // rossa
    },
    {
        "value": 12,
        "label": "Emessa" //verde piu acceso
    },
    {
        "value": 13,
        "label": "Archiviata" // Grigia
    } */
